import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noGroup: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noGroup: {
		id: 'issue-table-grouping.group-row.group-header.group-picker-group-header.no-group',
		defaultMessage: 'No group',
		description: 'Label for grouped items without group',
	},
});
export default messages;
